import React, { useState } from "react";

// v10-F1: "Zo lees je de Locatie-call" — elke regel beschrijft iets dat echt op deze pagina staat.
export function LocatieCallUitleg({ callWeek, vanafLabel, oversight, onBegrepen }) {
  const kop = callWeek ? ` "Calls van ${callWeek.callLabelLang} · over week ${callWeek.overWeekNr}"` : "";
  const regels = [
    `Bovenaan staat welke call je voert${kop ? `, nu${kop}` : ""}: je bespreekt de cijfers van de week ervoor en maakt afspraken voor deze week.`,
    `Op ${callWeek?.dagNaam || "de calldag"} zie je daaronder hoeveel locaties al klaar zijn: de cijfers, WOW en alle checks (beantwoord en afgevinkt). Bovenaan elke kaart staat wat nog nodig is voor klaar.`,
    `Groen is een locatie als omzet, PK en bijverkoop behaald zijn, en WOW ingevuld en niet Nee${vanafLabel ? `, vanaf de call van ${vanafLabel}; daarvoor: WOW niet Nee` : ""}.`,
    "Een ingeklapte kaart toont de strook van 13 weken en labels zoals \"Week 39 rood · omzet\" en hoeveel de locatie aanleverde, zoals \"Aangeleverd 5/7\".",
    "In een open kaart kies je per cijfer Ja of Nee. Bij Checks staat per check het antwoord van de locatie, jouw antwoord en wat je vorige keer schreef; klopt het antwoord van de locatie, neem het dan over met \"Neem over\". Het vinkje zet je tijdens de call.",
    "Een check kan ook om de week of eens per maand terugkomen; welke deze week niet aan de beurt zijn, staat onder de lijst. Alles wat de locatie aanleverde, staat in de lade \"Aangeleverd door de locatie\".",
    "Met \"Volgende locatie\" sla je op en open je de volgende kaart.",
  ];
  const [meer, setMeer] = useState(false);
  if (oversight) regels.push("Als oversight lees je de calls van elke OM mee; wijzigen kan alleen de OM van die calls.");
  return (
    <div data-testid="locatiecall-uitleg" className="bg-white border border-zinc-200 border-l-[3px] border-l-blue-600 rounded-[10px] px-3 py-2.5 mb-3 md:mb-4">
      <p className="font-heading font-bold text-sm text-zinc-900 mb-1">Zo lees je de Locatie-call</p>
      <ul className="space-y-0.5 text-[13px] text-zinc-700 list-disc pl-4">
        {/* op de telefoon eerst twee regels; de rest via 'Lees verder', zodat de eerste kaart dichtbij blijft */}
        {regels.map((r, i) => <li key={i} data-testid={`locatiecall-uitleg-regel-${i}`} className={i >= 2 && !meer ? "hidden sm:list-item" : ""}>{r}</li>)}
      </ul>
      <div className="mt-2 flex items-center gap-3">
        <button type="button" data-testid="locatiecall-uitleg-begrepen" onClick={onBegrepen}
          className="min-h-[44px] md:min-h-0 md:py-1.5 px-3 rounded-md bg-zinc-950 text-white text-xs font-semibold hover:bg-zinc-800 transition-colors">
          Begrepen
        </button>
        {!meer && (
          <button type="button" data-testid="locatiecall-uitleg-meer" onClick={() => setMeer(true)} className="sm:hidden min-h-[44px] text-xs font-semibold text-blue-700 hover:text-blue-900">
            Lees verder ({regels.length - 2} regels)
          </button>
        )}
      </div>
    </div>
  );
}
